/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Grid, useTheme } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { isRewardingAutoSelector } from 'reducers/challenge.reducer';
import { ICustomTheme } from 'interfaces';
import { currencySelector } from 'reducers/app.reducer';
import { StepType } from 'components/Stepper';
import { Text as StepperText } from 'components/Stepper/styles';

type Props = {
  index: number;
  step: StepType;
  numberOfStep?: number;
};

const GenericGoalStepTop = ({ step }: Props): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const currency = useSelector(currencySelector);
  const { id: challengeIdString }: { id: string } = useParams();
  const challengeId = Number(challengeIdString);
  const isRewardingAuto = useSelector(isRewardingAutoSelector(challengeId));

  return (
    <Grid
      container
      direction="column"
      justify="flex-end"
      css={{
        marginBottom: theme.spacing(3),
      }}
    >
      {isRewardingAuto && (
        <Grid item>
          <StepperText className={step.status}>
            {step.challengeReward?.value?.toLocaleString()}
            &nbsp;
            {currency}
          </StepperText>
        </Grid>
      )}
    </Grid>
  );
};

export default GenericGoalStepTop;
